import FilledButton from "../FilledButton";
import cancel from '../../assets/images/icon_cancel.svg';

const DeletePop = ({ handleDelete, handleOpenModal }) => {
    return (
        <div className="delete-pop">
            <img src={cancel} alt="" height="70" />
            <div className="title">
                Are you sure?
            </div>
            <div className="desc">
                Do you really want to delete these records? This process cannot be undone.
            </div>
            <div className="action">
                <FilledButton onClick={() => handleOpenModal()} value="cancel" />
                <FilledButton onClick={() => handleDelete()} value="delete" className="btn btn_primary" />
            </div>
        </div>
    )
};

export default DeletePop